// extracted by mini-css-extract-plugin
export var box = "_74-1";
export var checked = "_74-2";
export var descriptionSpacer = "_74-9";
export var disabled = "_74-3";
export var icon = "_74-6";
export var input = "_74-0";
export var labelSpacer = "_74-8";
export var medium = "_74-5";
export var small = "_74-4";
export var text = "_74-7";